import { Button, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Switch, useDisclosure, useToast } from "@chakra-ui/react";
import React from "react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


function Teacher_crud({ tittle, setFetchAgain }) {

    const { isOpen, onOpen, onClose } = useDisclosure()


    const toast = useToast();
    const [teacherId, setTeacherId] = useState("");
    const [teacherName, setTeacherName] = useState("");
    const [dob, setDob] = useState("");
    const [nationality, setNationality] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [pres, setPres] = useState(false);
    const [dis, setDis] = useState(false);
    const [picLoading, setPicLoading] = useState(true);



    const { user } = ChatState();

    const openModal = () => {
        setTeacherId("");
        setTeacherName("");
        setDob("");
        setNationality("");
        setPhone("");
        setEmail("");
        setPres(false);
        setDis(false);
        setPicLoading(false);
        onOpen()
    }
    const registerTeacher = async () => {

        if (!teacherId || !teacherName || !dob || !nationality || !phone || !email) {
            toast({
                title: "Veuillez remplir tous les champs",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });
            setPicLoading(false);
            return;
        }

        try {
            const config = {
                headers: {
                    "Content-type": "application/json",
                    Authorization: `Bearer ${user.token}`,
                },
            };
            await axios.post(
                "/api/teacher",
                {
                    teacherId,
                    teacherName,
                    dob,
                    nationality,
                    phone,
                    email,
                    pres,
                    dis
                },
                config
            );
            toast({
                title: "Inscription réussie",
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });


            setFetchAgain(true);
        } catch (error) {
            toast({
                title: "Une erreur s'est produite !",
                description: error.response.data.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "bottom",
            });

        }
        onClose()
    };


    return <>
        <Button bg='gray.50' className="p-2" onClick={() => { openModal() }}><i className="fa-solid fa-plus text-blue-400 mx-2"></i>Nouvel Professeur	</Button>
        <Modal

            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay />

            <ModalContent m='auto'>
                <ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-user-large text-xl mr-1"></i> Professeur</ModalHeader>

                <ModalBody pb={6}>

                    <div className="flex mt-5">
                        <div className="mr-4">
                            <FormControl >
                                <Input id='name' placeholder='Id' value={teacherId}
                                    onChange={(e) => setTeacherId(e.target.value)} />
                            </FormControl>

                            <FormControl mt={2}>
                                <Input id='name' placeholder='Nom et Prenom' value={teacherName}
                                    onChange={(e) => setTeacherName(e.target.value)} />
                            </FormControl>

                            <FormControl mt={4}>
                                <Input placeholder='Date de naissance' id='dob' value={dob}
                                    onChange={(e) => setDob(e.target.value)} />
                            </FormControl>

                            <FormControl mt={4}>
                                <Input placeholder='Nationality' id='nationality' value={nationality}
                                    onChange={(e) => setNationality(e.target.value)} />
                            </FormControl>




                        </div>
                        <div>
                            <FormControl>

                                <Input placeholder='Telephone' id='yearsOf' value={phone}
                                    onChange={(e) => setPhone(e.target.value)} />
                            </FormControl>
                            <FormControl mt={4}>

                                <Input placeholder='Email' id='yearsOf' value={email}
                                    onChange={(e) => setEmail(e.target.value)} />
                            </FormControl>
                            <div className="flex mt-4">
                                <FormControl mr="2">
                                    presential
                                    <Input type="checkbox" id='pres' checked={pres}
                                        onChange={(e) => setPres(e.target.checked)} />
                                </FormControl>
                                <FormControl ml="2">
                                    a Distance
                                    <Input className="" type="checkbox" id='dis' checked={dis}
                                        onChange={(e) => setDis(e.target.checked)} />
                                </FormControl>
                            </div>
                        </div>


                    </div>

                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}
                        onClick={registerTeacher}
                        isLoading={picLoading}>
                        Enregistrer
                    </Button>
                    <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>
}

export default Teacher_crud